import { render } from "./header-fixed.vue?vue&type=template&id=47251695&scoped=true"
import script from "./header-fixed.vue?vue&type=script&lang=js"
export * from "./header-fixed.vue?vue&type=script&lang=js"

import "./header-fixed.vue?vue&type=style&index=0&id=47251695&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47251695"]])

export default __exports__